import React, { useEffect, useState } from "react";
import Text from "../../../../Diathrive/src/components/elements/Text";
import Button from "../../../../Diathrive/src/components/elements/Button";
import { BUTTON_TYPES, COLORS } from "../../../../Diathrive/src/utils/Constants";
import { fetchApi } from "../../../../Diathrive/src/utils/ApiHelper";
import { HTTP_METHODS } from "../../../../Diathrive/src/utils/URLConstants";
import styles from "./styles";

const AppointmentTypeSelect = ({ onNext, onCancel }) => {
  const [eventTypes, setEventTypes] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchApi(HTTP_METHODS.GET, "patients/calendly/advisors")
      .then((response) => {
        const advisors = response.data.data.advisors;
        const types = advisors.flatMap((advisor) =>
          (advisor.eventTypes || []).map((et) => ({
            ...et,
            advisorName: `${advisor.firstname} ${advisor.lastname}`,
            advisorUri: advisor.advisorUri,
          }))
        );
        setEventTypes(types);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={styles.typeSelectContainer}>
      <Text variation="Subtitle2Bold" color={COLORS.black}>
        Select Appointment Type
      </Text>
      <Text variation="Text1Regular" color={COLORS.grey2} topMargin={4}>
        Choose the type of appointment you'd like to schedule.
      </Text>
      {loading ? (
        <Text variation="Text1Regular" color={COLORS.grey2} topMargin={24}>
          Loading available appointment types...
        </Text>
      ) : (
        eventTypes.map((et) => (
          <div
            key={et.uri}
            style={{
              ...styles.cardContainer,
              ...(selected?.uri === et.uri
                ? { borderWidth: 2, border: `2px solid ${COLORS.blueMain1 || COLORS.pink}` }
                : {}),
              cursor: "pointer",
            }}
            onClick={() => setSelected(et)}
          >
            <Text variation="Text2Medium" color={COLORS.grey2}>
              {et.advisorName}
            </Text>
            <Text variation="Subtitle2Bold" color={COLORS.black} topMargin={4}>
              {et.name}
            </Text>
            <Text variation="Text1Regular" color={COLORS.grey2} topMargin={4}>
              {et.duration} minutes
            </Text>
          </div>
        ))
      )}
      <div style={styles.typeSelectButtons}>
        <Button
          style={{ flex: 1 }}
          buttonType={BUTTON_TYPES.Bordered}
          title="Cancel"
          onPress={onCancel}
        />
        <Button
          disabled={!selected}
          style={{ flex: 1 }}
          buttonType={BUTTON_TYPES.Filled}
          titleColor={COLORS.white}
          title="Next"
          onPress={() => onNext(selected)}
        />
      </div>
    </div>
  );
};

export default AppointmentTypeSelect;
